import styled from 'styled-components'

export const H1 = styled.h1`
  font-family: 'FiraSansCompressed-Medium', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[4]};
  line-height: 100%;
  text-align: left;
  margin-top: 15rem;
  margin-left: 10rem;
  margin-bottom: 1.5rem;
`

export const H2 = styled.h2`
  font-family: 'FiraSansCompressed-Regular', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  color: ${({ theme }) => theme.colors.greys.mediumDark};
  line-height: 100%;
  font-variant-numeric: oldstyle-nums;
  text-align: left;
  margin-left: 10rem;
`

export const H3 = styled.h3`
  font-family: 'FiraSansCompressed-SemiBold', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  line-height: 5rem;
  text-align: left;
`

export const H4 = styled.h4`
  font-family: 'FiraSansCompressed-Medium', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[2]};
  line-height: 3.875rem;
  text-align: left;
  font-variant-numeric: oldstyle-nums;
`

export const H5 = styled.h5`
  font-family: 'FiraSansCompressed-SemiBold', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  line-height: 2.5rem;
`

export const H6 = styled.h6`
  font-family: 'FiraSans-ExtraLight', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  line-height: 2.5rem;
`

/* ************** CONTROLS ***************************** */

const Button = styled.button`
  font-family: 'FiraSansCompressed-Bold', sans-serif;
  letter-spacing: 0.0625rem;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
`

export const ButtonLarge = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes[2]};
  line-height: 1.875rem;
`

export const ButtonMedium = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes[1]};
  line-height: 2rem;
`

export const ButtonSmall = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes[0]};
  line-height: 0.75rem;
`

/* ************** OTHER ***************************** */

export const TextSmall = styled.div`
  font-family: 'FiraSans-Regular', sans-serif;
  font-size: ${({ theme }) => theme.fontSizes[0]};
  line-height: 1.75rem;
  /* TODO: (3) Check if text rendering 'geometicPrecision' should be enabled again */
  /* text-rendering: geometricPrecision; */
  font-variant-ligatures: common-ligatures;
  font-feature-settings: 'ss04', 'ss05';
  font-variant-numeric: oldstyle-nums;
`

export const TextLarge = styled(TextSmall)`
  font-size: ${({ theme }) => theme.fontSizes[1]};
  line-height: 2.5rem;
`

export const Label = styled(TextSmall)`
  font-family: 'FiraSansCompressed-Bold', sans-serif;
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
`

export const LabelLarge = styled(TextLarge)`
  font-family: 'FiraSansCompressed-Bold', sans-serif;
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
`
